module.exports = __webpack_public_path__ + "static/img/banner.f469e2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/banner.png
// module id = 358O
// module chunks = 44